export default __webpack_public_path__ + "static/media/President School.a50a783a.jpg";